var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("table", { staticClass: "directory-table" }, [
        _c("thead", [
          _c(
            "tr",
            [
              _vm._l(_vm.headers, function (header, index) {
                return _c(
                  "th",
                  {
                    key: index,
                    class: header.cls,
                    attrs: { colspan: index === 0 ? "2" : "1" },
                  },
                  [_vm._v("\n          " + _vm._s(header.title) + "\n        ")]
                )
              }),
              _vm._v(" "),
              _vm.showAction ? _c("th", { staticClass: "action" }) : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.tableContent, function (item, index) {
              return [
                _vm._l(item.companies, function (company, cIndex) {
                  return [
                    _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: cIndex === 0 || !_vm.collapseItems[index],
                            expression: "cIndex === 0 || !collapseItems[index]",
                          },
                        ],
                        key: company.id,
                        class: [
                          "main-comp",
                          (index + 1) % 2 === 1 ? "odd-item" : "even-item",
                        ],
                        attrs: { dirId: item.id },
                      },
                      [
                        _c("td", { staticClass: "collapse-icon" }, [
                          cIndex === 0 && company.subCompanies.length !== 0
                            ? _c("a", {
                                staticClass: "arrow-down",
                                class: { "arrow-up": _vm.collapseItems[index] },
                                on: {
                                  click: function ($event) {
                                    return _vm.collapse(index)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.headers, function (header, j) {
                          return _c(
                            "td",
                            { key: header.attr + "_" + j, class: header.cls },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "directory-table__value",
                                  class: {
                                    "field-hightLight": _vm.setHightLigth(
                                      item,
                                      "companies." + cIndex + "." + header.attr
                                    ),
                                  },
                                },
                                [
                                  header.routerLink
                                    ? _c("router-link", {
                                        attrs: {
                                          to: {
                                            name: _vm.detailRouterName,
                                            params: { id: item.id },
                                          },
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.vHtmlMainValue({
                                              header: header,
                                              cIndex: cIndex,
                                              company: company,
                                            })
                                          ),
                                        },
                                      })
                                    : _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.vHtmlMainValue({
                                              header: header,
                                              cIndex: cIndex,
                                              company: company,
                                            })
                                          ),
                                        },
                                      }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              header.attr === "status"
                                ? _c("div", [
                                    item.status === _vm.DIR_STATUS.CART
                                      ? _c("i", {
                                          staticClass:
                                            "fa fa-shopping-cart cart-icon",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status === _vm.DIR_STATUS.REJECTED
                                      ? _c("i", {
                                          staticClass: "fa fa-ban reject-icon",
                                          attrs: { "aria-hidden": "true" },
                                        })
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isTenant &&
                              header.attr === "engName" &&
                              !company.chsName &&
                              _vm.hasMaintainDirectoryPerms &&
                              item.type === "LOBBY" &&
                              company.chtName
                                ? _c("span", { staticClass: "no-cht-name" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("directory.hint.chinese")
                                        ) +
                                        "\n              "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.showAction
                          ? _c(
                              "td",
                              { staticClass: "action" },
                              [
                                cIndex === 0
                                  ? [
                                      _c(
                                        "div",
                                        { staticClass: "action__btns" },
                                        [
                                          _vm.showDirAction(item)
                                            ? _c("DirectoryActions", {
                                                attrs: {
                                                  item: item,
                                                  openLifecycleFun:
                                                    _vm.openRejectHistoriesModel,
                                                },
                                                on: {
                                                  "refresh:all": function (
                                                    $event
                                                  ) {
                                                    return _vm.$emit(
                                                      "refresh:all"
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.showDirCheck(item)
                                            ? [
                                                _vm.canCurrUserApprove
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa fa-check-circle-o pointer",
                                                      class: [
                                                        {
                                                          active:
                                                            _vm
                                                              .pendingApprItems[
                                                              item.id
                                                            ],
                                                        },
                                                      ],
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addToAppr(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm.canCurrUserApprove
                                                  ? _c("i", {
                                                      staticClass:
                                                        "fa fa-times-circle-o pointer",
                                                      class: {
                                                        active:
                                                          _vm
                                                            .pendingRejectItems[
                                                            item.id
                                                          ],
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addToReject(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm._l(company.subCompanies, function (subComp, sIndex) {
                      return [
                        !_vm.collapseItems[index]
                          ? _c(
                              "tr",
                              {
                                key: subComp.id,
                                staticClass: "sub-company",
                                class:
                                  (index + 1) % 2 === 1
                                    ? "odd-item"
                                    : "even-item",
                              },
                              [
                                _c("td"),
                                _vm._v(" "),
                                _vm._l(_vm.headers, function (header) {
                                  return _c(
                                    "td",
                                    { key: header, class: header.cls },
                                    [
                                      _c(
                                        "span",
                                        {
                                          class: {
                                            "field-hightLight":
                                              _vm.setHightLigth(
                                                item,
                                                "companies." +
                                                  cIndex +
                                                  ".subCompanies." +
                                                  sIndex +
                                                  "." +
                                                  header.attr
                                              ),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                subComp[header.attr] ||
                                                  _vm.getEmptyValue(
                                                    header.emptyValue,
                                                    "sub"
                                                  )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.isTenant &&
                                      header.attr === "engName" &&
                                      !subComp.chsName &&
                                      _vm.hasMaintainDirectoryPerms &&
                                      item.type === "LOBBY" &&
                                      subComp.chtName
                                        ? _c(
                                            "span",
                                            { staticClass: "no-cht-name" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "directory.hint.chinese"
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.showAction ? _c("td") : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(subComp.subDetails, function (detail, dIndex) {
                          return !_vm.collapseItems[index]
                            ? _c(
                                "tr",
                                {
                                  key: detail.id,
                                  staticClass: "sub-detail",
                                  class:
                                    (index + 1) % 2 === 1
                                      ? "odd-item"
                                      : "even-item",
                                },
                                [
                                  _c("td"),
                                  _vm._v(" "),
                                  _vm._l(_vm.headers, function (header) {
                                    return _c(
                                      "td",
                                      { key: header, class: header.cls },
                                      [
                                        _c(
                                          "span",
                                          {
                                            class: {
                                              "field-hightLight":
                                                _vm.setHightLigth(
                                                  item,
                                                  "companies." +
                                                    cIndex +
                                                    ".subCompanies." +
                                                    sIndex +
                                                    ".subDetails." +
                                                    dIndex +
                                                    "." +
                                                    header.attr
                                                ),
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  detail[header.attr] ||
                                                    _vm.getEmptyValue(
                                                      header.emptyValue,
                                                      "detail"
                                                    )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _vm.showAction ? _c("td") : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e()
                        }),
                      ]
                    }),
                  ]
                }),
              ]
            }),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "ActionConfirmModal",
        {
          ref: "rejectModal",
          attrs: {
            modalId: "reject-directory-modal",
            confirmBtnName: _vm.$t("action.reject"),
            confirmTitle: _vm.rejectCommentTitle,
            disabledConfirmBtn: _vm.disabledConfirmBtn,
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "content" }, slot: "content" },
            [
              _c("label", { staticClass: "font-bold" }, [
                _vm._v(_vm._s(_vm.$t("comment"))),
              ]),
              _vm._v(" "),
              _c("TextField", {
                attrs: {
                  value: _vm.rejectComment,
                  required: true,
                  placeholder: _vm.$t("hint.typeRejectComment"),
                },
                on: { inputValue: _vm.onUpdateRejectComment },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("Lifecycle", {
        ref: "directoryRejectLifecycle",
        attrs: {
          modalId:
            "directory-commments-modules-" + _vm.tableType + "-lifecycle-modal",
          type: "directoryCommentsHistory",
          commentAttr: _vm.lifecycleCommentAttrs.comments,
          showStatusCol: false,
          histories: _vm.rejectHistories,
          emptyHistoryHint: _vm.emptyCommentsHint,
          allowPreformattedComments: true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }